import Modal from "~/common/components/Modal";

import classes from "./NotificationSettingsConfirmationPopup.module.less";
import { Button, Stack } from "~/common/mui";
import { type ConfirmationModalProps } from "~/common/utils/ModalService";
import { resolveResourceURl } from "~/utils/url/urlResolver";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

interface Props extends ConfirmationModalProps {}
export const NotificationSettingsConfirmationPopup = ({ onConfirm, onCancel }: Props) => {
  const { t } = useTranslation();

  const footer = (
    <Stack gap={1} direction={"row"}>
      <Button onClick={onCancel} variant={"text"}>
        {t("cancel")}
      </Button>
      <Button onClick={onConfirm}>{t("updatePwd.confirm")}</Button>
    </Stack>
  );

  return (
    <Modal
      onClose={onCancel}
      footerChildren={footer}
      title={t("notification-settings-popup.confirmation.title")}
      modalClassName={classNames(classes.popup)}
    >
      <section className={classes.root}>
        <img className={classes.image} src={resolveResourceURl("/images/close_notification.svg")} />
        <p className={classes.text}>{t("notification-settings-popup.confirmation.description")}</p>
      </section>
    </Modal>
  );
};
